<template>
  <v-app id="app">
    <toolbar></toolbar>
    <nav-drawer></nav-drawer>

    <v-main>
      <v-container fluid>
        <v-layout align-center justify-left>
          <div class="container">
            <snackbar></snackbar>
            <loader></loader>
            <search-bar></search-bar>

            <router-view v-show="showRouterView"></router-view>
            <help style="position:fixed; bottom:40px; right: 25px;"></help>
          </div>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import SearchBar from "./components/SearchBar/search-bar";
import Toolbar from "./components/AppBar/toolbar";
import NavDrawer from "./components/NavigationBar/nav-drawer";
import Snackbar from "./components/Shared/snackbar";
import Loader from "./components/Shared/loader";
import Help from "./components/Shared/help";
export default {
  name: "app",
  components: {
    toolbar: Toolbar,
    navDrawer: NavDrawer,
    snackbar: Snackbar,
    loader: Loader,

    "search-bar": SearchBar,
    help: Help
  },
  created: async function() {
    //if (this.$store.state.securityModule.user.profile.sub != null)
    //{
    //  await this.$store.dispatch("messagingModule/getMessagingUser");
    //
    //}
  },
  mounted: async function() {
    //     if (this.$store.state.securityModule.user.profile.sub != null)
    //{
    //  await this.$store.dispatch("messagingModule/getMessagingUser");
    //  await this.$store.dispatch("messagingModule/getUsers");
    //  await this.$store.dispatch("messagingModule/loadConversationList");
    //}
  },
  computed: {
    showRouterView: function() {
      var requiresAuth = this.$router.currentRoute.meta.requiresAuth;
      return (
        !requiresAuth ||
        (this.$store.state.securityModule.requiresAuth &&
          this.$store.state.securityModule.isAuthenticated)
      );
    }
  }
};
</script>
<style>
.content {
  padding: 0px 0px;
}
</style>
